import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [prefs, setPrefs] = useState({ desempenho: false, funcionalidade: false, marketing: false });
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem('mh_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!visible) return null;

  const saveAndClose = (type: 'accepted' | 'rejected' | 'custom', customPrefs?: typeof prefs) => {
    const finalPrefs = type === 'accepted'
      ? { desempenho: true, funcionalidade: true, marketing: true }
      : type === 'rejected'
        ? { desempenho: false, funcionalidade: false, marketing: false }
        : customPrefs ?? prefs;

    localStorage.setItem('mh_cookie_consent', type);
    localStorage.setItem('mh_cookie_prefs', JSON.stringify(finalPrefs));
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-2xl mx-auto bg-gray-900 border border-white/10 rounded-2xl overflow-hidden shadow-2xl">
        {/* Main */}
        <div className="px-6 py-5">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 shrink-0 mt-0.5">
              <i className="ri-shield-check-line text-white text-lg" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white font-semibold text-sm mb-1">Usamos cookies 🍪</p>
              <p className="text-gray-400 text-xs leading-relaxed">
                Utilizamos cookies essenciais para o site funcionar e cookies opcionais para melhorar sua experiência e analisar o tráfego. Você pode aceitar todos, personalizar ou recusar os opcionais.{' '}
                <button
                  onClick={() => navigate('/politica-de-cookies')}
                  className="text-gray-300 hover:text-white underline underline-offset-2 cursor-pointer"
                >
                  Saiba mais
                </button>
              </p>
            </div>
          </div>
        </div>

        {/* Details expanded */}
        {showDetails && (
          <div className="px-6 pb-4 border-t border-white/8">
            <p className="text-gray-500 text-xs font-semibold uppercase tracking-widest mt-4 mb-3">Personalizar preferências</p>
            <div className="space-y-3">
              {[
                { id: 'desempenho', label: 'Desempenho e Análise', desc: 'Google Analytics e métricas de navegação (anonimizados)' },
                { id: 'funcionalidade', label: 'Funcionalidade', desc: 'Preferências de região, filtros e chat de suporte' },
                { id: 'marketing', label: 'Marketing e Publicidade', desc: 'Meta Pixel, Google Ads e rastreamento de campanhas' },
              ].map((item) => (
                <div key={item.id} className="flex items-center justify-between gap-4">
                  <div className="min-w-0">
                    <p className="text-white text-xs font-semibold">{item.label}</p>
                    <p className="text-gray-500 text-xs">{item.desc}</p>
                  </div>
                  <button
                    onClick={() => setPrefs((p) => ({ ...p, [item.id]: !p[item.id as keyof typeof p] }))}
                    className="relative shrink-0 cursor-pointer"
                    aria-label={`Toggle ${item.label}`}
                  >
                    <div className={`w-10 h-5 rounded-full transition-colors duration-200 ${prefs[item.id as keyof typeof prefs] ? 'bg-white' : 'bg-white/15'}`} />
                    <div className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full shadow transition-transform duration-200 ${prefs[item.id as keyof typeof prefs] ? 'translate-x-5 bg-gray-900' : 'translate-x-0 bg-white/60'}`} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="px-6 py-4 border-t border-white/8 flex flex-col sm:flex-row items-center gap-2">
          <button
            onClick={() => saveAndClose('rejected')}
            className="w-full sm:w-auto px-4 py-2 border border-red-500/40 text-red-400 text-xs font-semibold rounded-lg hover:border-red-400 hover:text-red-300 hover:bg-red-500/10 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-close-line mr-1" />
            Recusar
          </button>
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="w-full sm:w-auto px-4 py-2 border border-white/15 text-gray-300 text-xs font-semibold rounded-lg hover:border-white/30 hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            {showDetails ? 'Ocultar opções' : 'Personalizar'}
          </button>
          {showDetails ? (
            <button
              onClick={() => saveAndClose('custom', prefs)}
              className="w-full sm:w-auto px-4 py-2 bg-white/10 border border-white/20 text-white text-xs font-semibold rounded-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              Salvar seleção
            </button>
          ) : null}
          <button
            onClick={() => saveAndClose('accepted')}
            className="w-full sm:w-auto ml-auto px-5 py-2 bg-white text-gray-900 text-xs font-bold rounded-lg hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-checkbox-circle-line mr-1" />
            Aceitar Todos
          </button>
        </div>
      </div>
    </div>
  );
}
